import React, { useState } from "react";
import BasicInfoFields from "../BasicInfo/BasicInfoFields";
import { NavigationalButtons } from "./CreateChecklistWizard";
import Form from "../../../../Forms/Form";

const BasicInfoStep = ({ prevOnClick, isPublished, checklistId }) => {
  const [slugTaken, setSlugTaken] = useState(false);

  return (
    <div>
      <Form>
        <BasicInfoFields
          isPublished={isPublished}
          checklistId={checklistId}
          onSlugTakenChange={setSlugTaken}
        />
        <NavigationalButtons
          onNextProps={{
            type: "submit",
            text: "Save and Continue",
            disabled: slugTaken,
          }}
          onPrevHandler={prevOnClick}
        />
      </Form>
    </div>
  );
};

export default BasicInfoStep;
